import { apiPaths } from '../../config'
import { http } from '../../services/index'
import { factorySetStateAction } from '../factory'
// Defined Device Constants to bind SAGA functions with Redux Dispatcher
const actions = {
  SET_STATE: 'notifications/SET_STATE',
  GET_NOTIFICATIONS: 'notifications/GET_NOTIFICATIONS',
  GENERATE_NOTIFICATION: 'notification/GENERATE_NOTIFICATION',
  GET_RR_NOTIFICATIONS: 'notification/GET_RR_NOTIFICATIONS',
  NOTIFICATION_SEEN: 'notification/NOTIFICATION_SEEN',
  NOTIFICATION_READ_ALL: 'notification/NOTIFICATION_READ_ALL',
}

// function getMyInIt(data) {
//   const myInit = {
//     // OPTIONAL
//     headers: {}, // OPTIONAL
//     queryStringParameters: data,
//   }
//   return myInit
// }

export const notificationsSetState = factorySetStateAction(actions.SET_STATE)

// API call to get a List of All Devices filtered by the current logged in Provider if a Provider is logged in, or unfiltered if Superadmin is logged in.
export const getNotifications = async (data) =>
  http
    .get(apiPaths.Clinic.apiNotificationList, Object.keys(data).length > 0 ? data : '')
    .then((res) => res)
    .catch(() => [])

export const notificationSeen = async (data) =>
  http
    .post(apiPaths.Clinic.apiNotificationSeen, { id: data.id }, {})
    .then((res) => res)
    .catch(() => [])

export const notificationSeenAll = async (data) =>
  http
    .post(apiPaths.Clinic.apiNotificationSeenAll, data, {})
    .then((res) => res)
    .catch(() => [])

export default actions
